<template>
  <v-app class="bg-secondary">
    

    <v-main class="pb-4 bg-white">
      <v-row  class="bg-secondary pb-5 px-9 pt-4" wrap>
        
          <v-col align-self="center" >
            <router-link to="/">
                          <v-img
                              class="float-left"
                              :class="{
                                'ml-10': smAndUp
                              }"
                              :src="logo"
                              height="80"
                              width="auto"
                              contain
                            ></v-img>
            </router-link>
          </v-col>
        
          <v-col
            cols="12"
            sm="8"
            md="3"
            class="d-flex justify-center" 
            align-self="center" 
          >
            <v-btn
              variant="elevated"
              color="primary"
              size="large"
              href="https://icjk.darujme.sk/podporte-investigativne-centrum-jana-kuciaka/"
              target="_blank"
              class="w-100"
              height="48"
            >
              Podporiť
           </v-btn>
          </v-col>
                  <v-col
                      cols="12"
                      sm="6"
                      md="3"
                      :class="{ 'mt-7': smAndDown }"
                      align-self="center" 
                    >
                    
                      <v-text-field
                        v-model="searchData"
                        label="Vyhľadať článok"
                        variant="solo"
                        hide-details
                        density="comfortable"
                        clearable
                        @keydown="searchKeydown"
                        @click:append-inner="search"
                      >
                      <template #prepend-inner>
                        <v-icon @click="searchData = ''">mdi-close</v-icon>
                      </template>
                        <!-- ikona vpravo (append-inner) -->
                        <template #append-inner>
                          <v-icon @click="search" class="cursor-pointer">mdi-magnify</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
        
      </v-row>
        <v-toolbar  v-if="mdAndUp" flat max-width="100%" :class="{ dense_toolbar: xs }">
          <v-btn 
              v-for="(item, i) in menu"
              :key="'menu' + i"
              v-model="group"
              variant="text" 
              tile
              :to="item.to"
              style="height: 64px"
              :href="item.href"
              :target="item.target"
              :width="xs ? 100 / menu.length + 'vw' : undefined"
              :class="{ 'bg-primary': route.path === item.to }"
             
              class="text-center primary font-weight-regular"
            >{{ item.title }}
            </v-btn>
         
        </v-toolbar>
      <v-row no-gutters  v-if="smAndDown" class="mt-3">
            <v-col style="overflow:hidden;">
              <v-toolbar-items 
                  style="height:58px"
                  variant="elevated"
                  color="primary"
                >
                <v-btn
                  text block
                  :to="menu[0].to" 
                  :width="xs?100/menu.length+'vw':null"
                  active-class="primary" 
                  class="text-center"
                >{{ menu[0].title }}
                </v-btn></v-toolbar-items>
                <v-expand-transition>
                    <div v-show="drawer" >
                      <v-toolbar-items 
                        v-for="(item,i) in menu.slice(1)" 
                        :key="'menu'+i" style="height:58px" 
                      >
                      <v-btn
                        text block
                        :to="item.to"
                        :href="item.href"
                        :target="item.target" 
                        :width="xs?100/menu.length+'vw':null"
                        active-class="primary" 
                        class="text-center"
                      >{{ item.title }}
                      </v-btn></v-toolbar-items></div>
                  </v-expand-transition>
            </v-col>
            <v-col style="display:flex; justify-content:flex-end;"><v-toolbar-items style="height:58px">
              <v-btn text size="large" @click="drawer = !drawer"><v-icon>mdi-menu</v-icon></v-btn></v-toolbar-items>
            </v-col>
          
          </v-row>
        

      <v-card
        v-if="0"
        ripple
        style="cursor: pointer;width:1000px "
        to="/2-percenta-dani"
        class="flat display-2 pa-4 primary text-white" 
        :class="{
          'display-2 pl-10': smAndUp,
          'headline': xs
        }"
      >
        <v-row style="max-width: 1000px; margin: auto;">
          <v-col class="pa-0" align-self="center" >
            Darujte 2 % daní pre <div class="black--text">Investigatívne Centrum Jána Kuciaka</div>
          </v-col>
          <v-col class="shrink pa-0">
            <v-img max-width="128" style="border-radius: 100%;width:1000px " :src="require('./assets/img_icjk_baner_2percenta.jpg')"/>
          </v-col>
        </v-row>
      </v-card>
      <RouterView
      :key="route.path"
      ></RouterView>
<v-row justify="center" class="bg-white" :class="{'pt-4 pb-8':!loadingContent}" >
       <v-btn 
        v-if="route.fullPath.indexOf('/225') !== -1"
        color="secondary"
        @click="resetCookies"
      >
        Resetovať cookies
      </v-btn>     
          </v-row>
      
      
    </v-main>

    <v-footer>
      
        <v-row style="max-width: 1000px; background-color: #e0e0e0;" class="mx-auto pa-4" >
          <v-col cols="12" md="3" order="1">
            <h3 class="mb-4">PARTNERI</h3>
            <div>
              
              <v-row dense justify="center">
                <v-col v-for="partner in partners" :key="partner.link" 
                  cols="6" sm="4" md="12">
                <a :href="partner.link" target="_blank">
                  <img 
                    :src="partner.img ?? null" 
                    :title="partner.title"
                    style="max-height: 65px; max-width: 100%;"
                  />
                </a>
                </v-col>
              </v-row>
              
            </div>
          
          </v-col>
          <v-col cols="12" md="3" order="3" order-sm="2">
            <h3 class="mb-4">KONTAKT</h3>
            <v-row dense>
              <v-col cols="12">
                Investigatívne centrum Jána Kuciaka<br>
                P.O.BOX 8/D<br>
                810 00 Bratislava 1<br>
                IČO 51820897<br>
                EV 80/23/SWP
              </v-col>
              <v-col>
            <a href="https://www.facebook.com/icjk.sk" target="_blank" class="text-secondary"><img height="24" style="vertical-align: middle;" :src="require('./assets/facebook.png')" class="mr-2"></a>
              </v-col>
               <v-col>
            <a href="https://www.instagram.com/icjk.sk/" target="_blank" class="text-secondary"><img height="24" style="vertical-align: middle;" :src="require('./assets/instagram.png')" class="mr-2"></a>
              </v-col>
              <v-col >
            <a href="https://www.youtube.com/channel/UCPQY77IlYZN_wwSXpfipXHA" target="_blank" class="text-secondary"><img height="24" style="vertical-align: middle;" :src="require('./assets/youtube.png')" class="mr-2"></a>
              </v-col>
              <v-col>
            <a href="https://twitter.com/ICJK_sk" target="_blank" class="text-secondary"><img height="24" style="vertical-align: middle;" :src="require('./assets/twitter.png')" class="mr-2"></a>
              </v-col>
              <v-col >
            <a href="https://sk.linkedin.com/company/investigativne-centrum-jana-kuciaka" target="_blank" class="text-secondary"><img height="24" style="vertical-align: middle;" :src="require('./assets/linkedin.png')" class="mr-2"></a>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="3" order="4" order-sm="3" >
            <v-row >
              <v-col 
                v-for="(item,i) in footer" 
                :key="'menu'+i" 
                cols="12"
                class="pa-0"
                :align="smAndDown?'center':'start'"
              >
                <v-btn 
                  text 
                  :to="item.to" 
                  :width="xs?100/menu.length+'vw':null"
                  class="text-center font-weight-regular"
                  block
                  variant="text"
                >{{ item.title }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="3" order="2" order-sm="4" >
                <h3 class="mb-4">ICJK PODPORUJÚ</h3>
                
                  
                  
                <v-row dense justify="center">
                  <v-col 
                    v-for="(supporter) in supporters"
                    :key="supporter.link" 
                    cols="6" sm="4" md="12"
                    class="text-center"
                  >

                    <a :href="supporter.link" style="display: inline-block; max-width: 150px;" target="_blank">
                      <img 
                        :src="supporter.img ?? null" 
                        :title="supporter.title"
                        style="max-width: 100%; max-height: 80px"
                      />
                    </a>

                   
                    <div 
                      v-if="supporter.info"
                      class="font-weight-light caption supporter-info"
                    >
                      {{ supporter.info }}
                    </div>
                  </v-col>
                </v-row>    
              </v-col>
        </v-row>
         
        
    </v-footer>
    <v-card 
      v-if="supportDialog"
      width="290"
      style="position: fixed; right: 8px; bottom: 8px;"
    >
      <v-card-title primary-title class="title bg-primary text-white py-2">
        <v-row>
          <v-col cols="10" class="py-0 pr-0">
            Podporte Investigatívne<br>
            centrum Jána Kuciaka
          </v-col>
          <v-col cols="2" class="shrink pa-0 pr-2 text-right">
            <v-btn variant="text" small icon dark @click="closeSupportDialog"><v-icon small>mdi-close</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="caption text-justify pt-3">
        <div class="subtitle-2">Naša spoločnosť nevyhnutne potrebuje investigatívnu žurnalistiku.</div> My v Investigatívnom centre Jána Kuciaka ju robíme nezávislo a pokračujeme v jeho odkaze spolupráce a hľadania pravdy. Spoločne s inými médiami napríklad analyzujeme dáta takzvanej Kočnerovej knižnice a prichádzame s novými odhaleniami. Nešlo by to však bez Vašej podpory. Vaše dary posilňujú našu nezávislosť.
      </v-card-text>
      <v-card-actions class="pa-4 pt-0">
        <v-btn block to="/226/Podporte-nas" variant="elevated" color="primary" dark @click="supportDialog = false" >Podporiť</v-btn>
      </v-card-actions>
    </v-card>
  <!-- <vue-cookie-accept-decline
      ref="cookieBanner"
      :debug="false"
      position="bottom-left"
      type="floating"
      :disableDecline="false"
      transitionName="slideFromBottom"
      show-postpone-button
      @removed-cookie="cookieRemovedCookie"
      @status="cookieStatus"
      >
  
     
      <template #message>
          Toto webové sídlo používa analytické súbory Cookies na získanie informácií o jeho návštevnosti. Ďalšie informácie o tom, ako používame Cookies, nájdete <a href="https://www.icjk.sk/225/Politika-pouzivania-cookies-" target="_blank">tu</a>.
      </template>
  
    
      <template #declineContent>
        Odmietnuť
      </template>
  
      <template #acceptContent>
          Prijať
      </template>
      
  </vue-cookie-accept-decline>   -->
  </v-app>
</template>


<script setup>
import logo from '@/assets/ICJK_logo3_80.png'  // alias @ = src/
import { useDisplay } from 'vuetify'
//import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { useRoute, useRouter } from 'vue-router'
import { ref, computed, watch, onMounted, useTemplateRef } from 'vue';
import VueCookies from 'vue-cookies'

const { xs, smAndUp, mdAndUp, smAndDown } = useDisplay()
const route = useRoute()
const router = useRouter()
console.log('route', route.fullPath)


// State
const drawer = ref(false)
const searchData = ref('')
const supportDialog = ref(false)
const group = ref(null)
const cookieBanner =  useTemplateRef('cookieBanner')

// Footer links
const footer = [
  {title: 'Etický kódex', to: '/ethics'},
  {title: 'O nás', to: '/223/O-nas'},
  {title: `Podporte nás`, to: '/226/Podporte-nas'},
  {title: `Darujte 2%`, to: '/227/Ako-poukazat-Investigativnemu-Centru-Jana-Kuciaka'},
  {title: `Ochrana osobných údajov`, to: '/224/Informacia-o-spracuvani-osobnych-udajov'},
  {title: `COOKIES`, to: '/225/Politika-pouzivania-cookies-'},
  {title: `RSS`, href: '/rss', target: '_blank' }
]

// Partner logos
const partners = [
  {img: new URL('./assets/Investigacecz-logo.png', import.meta.url).href, title: 'Investigace.cz', link: 'https://www.investigace.cz/'},
  {img: new URL('./assets/OCCRP_logo.png', import.meta.url).href, title: 'Organized Crime and Corruption Reporting Project', link: 'https://www.occrp.org'},
  {img: new URL('./assets/vsquare-logo.png', import.meta.url).href, title: 'VSQUARE.ORG', link: 'https://www.vsquare.org'},
  {img: new URL('./assets/gijn.png', import.meta.url).href, title: 'Global Investigative Journalism Network', link: 'https://www.gijn.org'},
  {img: new URL('./assets/rsf-org-logo.png', import.meta.url).href, title: 'Reporters Sans Frontières', link: 'https://rsf.org/en'}
]

// Supporters logos
const supporters = [
  {img: new URL('./assets/limelight-logo.png', import.meta.url).href, title: 'Limelight', link: 'https://limelight.foundation/', info: 'Podporené grantom Limelight' },
  {img: new URL('./assets/civitates_logo.png', import.meta.url).href, title: 'Civitates', link: 'https://civitates-eu.org/', info: 'Podporené grantom Civitates' },
  {img: new URL('./assets/fondu_logo.png', import.meta.url).href, title: 'Fondu', link: 'https://www.fondu.sk/', info: 'Projekt bol podporený Nadáciou otvorenej spoločnosti v rámci Nadačného fondu Ü' }
]

// Menu items
const menu = computed(() => {
  return [
    {title: 'Články', to: '/'},
    {title: 'O nás', to: '/223/O-nas'},
    {title: `Podporte nás`, to: '/226/Podporte-nas'},
    {title: `Darujte 2%`, to: '/227/Ako-poukazat-Investigativnemu-Centru-Jana-Kuciaka'},
    {title: `Podcast`, to: '/120/Odhalenie-podcast-ICJK'},
    {title: 'BEZPECNA.ZURNALISTIKA.SK', href: 'https://bezpecna.zurnalistika.sk',target:'_blank'},
  ]
})

// Methods
const search = () => {
  router.push('/search/' + searchData.value)
}

const searchKeydown = (e) => {
  if(e.keyCode == 13){
    search()
  }
}
// Lifecycle hooks
onMounted(() => {
  if(JSON.parse(localStorage.getItem('preventSupportDialog') || 'false') !== true){
    supportDialog.value = true
  }
})

// Watchers
watch(route, () => {
  window.scrollTo({
    top: 100,
    left: 100,
    behavior: 'smooth'
  })
  drawer.value = false
})

// Functions

function closeSupportDialog() {
  supportDialog.value = false
  VueCookies.set('preventSupportDialog', '1', '30d')
}

function resetCookies() {
  cookieBanner.value.removeCookie()
  window.location.reload()
}

</script>
<style>
  @import '../node_modules/vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css';
  .dense_toolbar .v-toolbar__content{
    padding: 0 !important;
  }
  .v-application{
    overflow: hidden;
  }
  .firstArticle > .v-img__img{
    transform: scaleX(-1) scale(1.1);
    filter: blur(15px) brightness(0.5);
  }
  .articleHeadline{
    position: absolute;
    bottom: 0;
    background: rgba(0,0,0,0.6);
    color: white;
    width: 100%;
  }
  .cookie__floating__postpone-button{
      color: #666 !important;
      position: absolute;
      right: 23px;
      top: 0;
  }
  .rss-btn {
    display: inline-block;
    background-color: #ff6600;
    color: white;
    padding: 10px 16px;
    border-radius: 6px;
    text-decoration: none;
    font-weight: bold;
  }
  .rss-btn:hover {
    background-color: #e65c00;
  }
  p { 
    padding: revert;
    margin: revert;
  }
</style>
<style scoped>
.v-toolbar__content > .v-btn:first-child {
  margin-inline-start: 16px !important;
}

:deep(.cookie__floating__content) {
  color: black !important; /* alebo farba podľa potreby */
}
.supporter-info {
  font-size: 0.6em;
  font-style: italic;
}

</style>
